// Custom JS

jQuery(document).ready(function($) {
	
    // Submit searchform on enter

    $('#searchform input').keydown(function(e) {
        if (e.keyCode == 13) {
            this.form.submit();
        }
    });	

    // Slick-carousel
  	$('.gallery-slider').slick({
      dots: true,
      adaptiveHeight: true,
       infinite: true,
       slidesToShow: 3,
  		slidesToScroll: 3,
  		responsive: [
		    {
		      breakpoint: 640,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3
		      }
		    }
		  ]
    });

     $("#searchinput").on('focus blur', function(){
       $("#searchform").toggleClass('is_focused');
    })






      // $(".loadmorebutton").click(load_more_blog_posts);

      // var blogOffset = 12;

      // function load_more_blog_posts() {

      //   console.log("loading more blog posts");

      //   $.ajax({
      //     url: '/wp-json/wp/v2/posts?categories=4&status=publish&per_page=8&_embed&offset='+blogOffset,
      //     success: function(data) {
      //       if (!data.length) {
      //         $('.loadmore').append('<p class="text-center"><small class="muted">All posts shown</small></p>');
      //         $('.loadmorebutton').fadeOut(300);

      //       }
      //       data.forEach(function(post) {
      //         console.log(post);

      //         var myExcerpt = post.acf && post.acf.excerpt ? post.acf.excerpt : stripHTML(post.content.rendered.substring(0,250)) + '…';
      //         if (typeof (post._embedded['wp:featuredmedia']) == 'object') {
      //             var thumbnail = post._embedded['wp:featuredmedia'][0].source_url;

      //              $('.blogcontainer').append(

      //           '<div class="column blogcolumn"><a data-wow-delay=".3s" href="'+post.link+'" class="more-link-wrapper link-wrapper wow fadeInUp"><div class="blogthumbnail" style="background: url('+thumbnail+') no-repeat center center; background-size: cover; height: 300px; width: 100%;"></div><div class="p-4 bg-off-white blogexcerpt"><span class="bg-step-1 post-type">Blogi</span><h2>'+post.title.rendered.replace(/(<([^>]+)>)/ig,"")+'</h2><p>'+ myExcerpt +'</p><p class="readmore"><span class="step-1">→ Lue lisää</span></p></div></a></div>'


      //           );
      //         }

      //         else {
      //             var placeholder = '/wp-content/themes/ambientia/assets/images/image-placeholder.svg';

      //              $('.blogcontainer').append(

      //           '<div class="column blogcolumn"><a data-wow-delay=".3s" href="'+post.link+'" class="more-link-wrapper link-wrapper wow fadeInUp"><div class="blogthumbnail" style="background: url('+placeholder+') no-repeat center center; background-size: cover; height: 300px; width: 100%;"></div><div class="p-4 bg-off-white blogexcerpt"><span class="bg-step-1 post-type">Blogi</span><h2>'+post.title.rendered.replace(/(<([^>]+)>)/ig,"")+'</h2><p>'+ myExcerpt +'</p><p class="readmore"><span class="step-1">→ Lue lisää</span></p></div></a></div>'


      //           );
      //         }

             

      //         blogOffset = blogOffset + 8;
      //       });
      //     },
      //     error: function(error) {
      //       alert("Error loading posts");
      //     }
      //   });
      // }

}); 